import React, { useState } from 'react';
import { ENV_CONFIG } from '../../config';

const DebugLoginPage = ({ onDebugLogin }) => {
  // デフォルトのデバッグトークンを設定
  const defaultToken = '';

  const [token, setToken] = useState(defaultToken);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async () => {
    if (!token.trim()) {
      setError('トークンを入力してください');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // デバッグトークンでログイン試行
      await onDebugLogin(token.trim());
    } catch (err) {
      setError('ログインに失敗しました: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleLogin();
    }
  };

  const handleClear = () => {
    setToken('');
    setError('');
  };

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center bg-gray-100 p-8">
      <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">デバッグモード</h1>
          <p className="text-sm text-gray-600">
            開発・テスト用のトークン入力画面です
          </p>
          {ENV_CONFIG.DEBUG && (
            <p className="text-xs text-blue-600 mt-2">
              DEBUG={ENV_CONFIG.DEBUG.toString()}
            </p>
          )}
        </div>

        <div className="space-y-4">
          <div>
            <label htmlFor="debug-token" className="block text-sm font-medium text-gray-700 mb-2">
              IDトークン
            </label>
            <textarea
              id="debug-token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Bearer トークンを入力してください..."
              className="w-full border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
              rows="4"
              disabled={loading}
            />
          </div>

          <div className="flex gap-2">
            <button
              onClick={handleClear}
              className="flex-1 py-2 px-3 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
              disabled={loading}
            >
              クリア
            </button>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
              <p className="text-red-600 text-sm">{error}</p>
            </div>
          )}

          <button
            onClick={handleLogin}
            disabled={loading || !token.trim()}
            className={`w-full py-3 px-4 rounded-lg font-semibold transition-colors ${loading || !token.trim()
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'ux-bg-blue text-white hover:bg-blue-700 active:bg-blue-800'
              }`}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                ログイン中...
              </div>
            ) : (
              'ログイン'
            )}
          </button>
        </div>

        <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <h3 className="text-sm font-semibold text-blue-800 mb-2">使用方法:</h3>
          <ul className="text-xs text-blue-700 space-y-1">
            <li>• デフォルトボタンでテスト用トークンを自動入力</li>
            <li>• または独自のBearerトークンを入力</li>
            <li>• このモードは開発・テスト目的でのみ使用してください</li>
          </ul>
        </div>

        <div className="mt-4 text-center">
          <p className="text-xs text-gray-500">
            本番環境では表示されません
          </p>
        </div>
      </div>
    </div>
  );
};

export default DebugLoginPage;